import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import cashCreditActions from 'actions/cash_credit.actions';
import userActions from 'actions/user.actions';
import { connect } from 'react-redux';
import _ from 'lodash';
import Autosuggest from 'react-autosuggest';

//import avatar from "assets/img/faces/face-3.jpg";

class AddCashCredit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      cashCredit: {
        user: '',
        userInput: '',
        amount: '',
        description: ''
      },
      suggestions: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.userSelected = this.userSelected.bind(this);
    this.onUsersFetchRequested = this.onUsersFetchRequested.bind(this);
    this.onUsersClearRequested = this.onUsersClearRequested.bind(this);
    this.fetchUsersWithDebounce = _.debounce(this.onUsersFetchRequested, 1500);
  }

  handleChange(e) {
    const { name, value } = e.target;
    let cashCredit = this.state.cashCredit;
    cashCredit[name] = value;
    this.setState({ cashCredit: cashCredit });
  }

  userSelected(event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) {
    let cashCredit = this.state.cashCredit;
    cashCredit.user = suggestionValue;
    cashCredit.userInput = suggestion.firstName + " " + suggestion.lastName;
    this.setState({cashCredit: cashCredit});
  }

  onUsersFetchRequested = ({ value }) => {
    if(this.state.cashCredit.user && value) {
      if(_.find(this.state.suggestions, {id: this.state.cashCredit.user, firstName: value.split(" ")[0], lastName: value.split(" ")[1]})) {
        this.setState({suggestions: []});
        return;
      }
    }
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if(inputLength === 0) {
      this.setState({suggestions: []});
      return;
    }
    if(inputLength >= 3) {
      if(inputValue.indexOf(" ") > -1) {
        this.props.dispatch(userActions.getUsers({filtered: JSON.stringify([{id: 'firstName', value: inputValue.split(" ")[0]}, {id: 'lastName', value: inputValue.split(" ")[1]}])}));
      }
      else {
        this.props.dispatch(userActions.getUsers({filtered: JSON.stringify([{id: 'firstName', value: inputValue}])})); 
      }
    }
  };

  onUsersClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { dispatch } = this.props;
    if (this.state.cashCredit.user && this.state.cashCredit.description && this.state.cashCredit.amount) {
      dispatch(
        cashCreditActions.add({
          user: this.state.cashCredit.user,
          amount: this.state.cashCredit.amount,
          description: this.state.cashCredit.description
        })
      );
    }
  }

  componentWillUpdate(props) {
    if(props.error && !this.props.error) {
      this.props.addNotification({type: 'error', message: props.error});
    }
    if(props.success && !this.props.success) {
      this.props.addNotification({type: 'success', message: 'CashCredit Added successfully'});
      this.setState({
        cashCredit: {
          user: '',
          description: '',
          amount: '',
          userInput: ''
        },  
        submitted: false
      });
    }
    if(props.users && JSON.stringify(props.users) !== JSON.stringify(this.state.suggestions)) {
      this.setState({suggestions: props.users});
    }
  }

  render() {
    const { submitted, cashCredit, suggestions } = this.state;
    const { loading } = this.props;
    const getSuggestionValue = suggestion => suggestion.id;
    const renderSuggestion = suggestion => (
      <div>
        {suggestion.firstName + " " + suggestion.lastName}
      </div>
    );
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Add Credit"
                content={
                  <form name="profileForm" onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>User</ControlLabel>
                          <Autosuggest
                            suggestions={suggestions}
                            onSuggestionsFetchRequested={this.fetchUsersWithDebounce}
                            onSuggestionsClearRequested={this.onUsersClearRequested}
                            getSuggestionValue={getSuggestionValue}
                            renderSuggestion={renderSuggestion}
                            onSuggestionSelected={this.userSelected}
                            inputProps={{
                              name: 'userInput',
                              value: cashCredit.userInput,
                              placeholder: 'User',
                              onChange: this.handleChange,
                              className: 'form-control'
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Amount</ControlLabel>
                          <FormControl placeholder="Amount" type="number" bsClass= "form-control" name="amount" value={cashCredit.amount} onChange={this.handleChange}></FormControl>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="error-row">
                      <Col md={6}>{submitted && !cashCredit.user && <div className="error">User is required</div>}</Col>
                      <Col md={6}>{submitted && !cashCredit.amount && <div className="error">Amount is required</div>}</Col>
                    </Row>
                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "Description",
                          componentClass: "textarea",
                          bsClass: "form-control",
                          placeholder: "Description",
                          value: cashCredit.description,
                          name: 'description',
                          onChange: this.handleChange
                        }
                      ]}
                    />
                    <Row className="error-row">
                      <Col md={12}>{submitted && !cashCredit.description && <div className="error">Description is required</div>}</Col>
                    </Row>
                    <Button bsStyle="info" disabled={loading} fill type="submit">
                      Add Credit
                    </Button>
                    {loading && submitted && 
                      <img alt="" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { loading, error, success } = state.cashCredits;
  return {
    loading, error, success, users: state.users.items
  };
}
 
export default connect(mapStateToProps)(AddCashCredit);
